const superAdmin = {
  id: 'Pf5kopbedfcbEWAlW6LmfabZ5A13',
  email: 'craig@ringmarketing.net',
  username: 'craig@ringmarketing.net',
  firstName: 'Craig',
  lastName: 'SuperAdmin',
  fullName: 'Craig SuperAdmin',
  lastModified: 1521738144176,
  created: 1521738144176,
  role: 'Super Administrator',
  isTeacher: false,
}

export default superAdmin


// WEBPACK FOOTER //
// ./src/helpers/users/testing/superAdminUser.js